import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Button = ({ label, icon, bgColor, color, id }) => {
  const ButtonBase = styled.button`
    background-color: ${bgColor && bgColor};
    color: ${color && color};
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    border: 0;
    height: 54px;
    padding: 0 20px;
    border-radius: 4px;
    transition: 0.2s all ease;
    .icon {
      margin-right: 8px;
    }
    &:hover {
      filter: brightness(105%);
    }
    &:active {
      filter: brightness(95%);
    }
    &:focus {
      outline: 0;
    }
  `;
  return (
    <ButtonBase id={id}>
      {icon && <FontAwesomeIcon icon={icon} className="icon" />}
      {label}
    </ButtonBase>
  );
};

Button.defaultProps = {
  bgColor: '#3c5975',
  color: 'white',
  id: null,
};

export default Button;
